import { Injectable } from '@angular/core';
import { FormularioPresupuesto } from '../app.domain.models/formulario-presupuesto';
import { ArchivoQuery } from '../app.domain.queries/archivo.query';
import { ArchivoRepository } from '../app.domain.repository/archivo.repository';
import { Archivo } from '../core.models/archivo';
import { GenericEntityService } from '../core.utilidades/generic-entity.service';
import { getGQLQueryString } from '../core.utilidades/graphql-utils';
import { FormularioSolicitudReducirCapital } from '../app.domain.models/formulario-solicitud-reducir-capital';
import { FormularioSolicitud } from '../app.domain.models/formulario-solicitud';
import { FormularioSolicitudCambiarBeneficiarios } from '../app.domain.models/formulario-solicitud-cambiar-beneficiarios';

@Injectable({
    providedIn: 'root',
})
export class PdfApiService extends ArchivoRepository implements GenericEntityService<Archivo> {

    public generarPdfColectivoCompanniaAnonimo(polizaId: number): Promise<Archivo> {
        const variables = { polizaId };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfColectivoCompanniaAnonimo, variables), variables);
    }

    public generarPdfColectivoCompanniaCompleto(polizaId: number): Promise<Archivo> {
        const variables = { polizaId };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfColectivoCompanniaCompleto, variables), variables);
    }

    public generarPdfColectivoCobertura(instancia: FormularioPresupuesto): Promise<Archivo> {
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfColectivoCobertura, variables, 'FormularioPresupuesto'), variables);
    }

    public generarPdfIndividualCobertura(instancia: FormularioPresupuesto): Promise<Archivo> {
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfIndividualCobertura, variables, 'FormularioPresupuesto'), variables);
    }

    public generarPdfSolicitud(instancia: FormularioSolicitud): Promise<Archivo> {
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfSolicitud, variables, 'FormularioSolicitud'), variables);
    }

    public generarPdfSolicitudReducirCapital(instancia: FormularioSolicitudReducirCapital): Promise<Archivo> {
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfSolicitudReducirCapital, variables, 'FormularioSolicitudReducirCapital'), variables);
    }

    public generarPdfSolicitudCambiarBeneficiarios(instancia: FormularioSolicitudCambiarBeneficiarios): Promise<Archivo> {
        const variables = { instancia };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.generarPdfSolicitudCambiarBeneficiarios, variables, 'FormularioSolicitudCambiarBeneficiarios'), variables);
    }

    public rellenarAkibuPdf(polizaId: number): Promise<Archivo> {
        const variables = { polizaId };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.rellenarAkibuPdf, variables), variables);
    }
   
    public rellenarAkibuPdfSinNumeroPoliza(polizaId: number): Promise<Archivo> {
        const variables = { polizaId };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.rellenarAkibuPdfSinNumeroPoliza, variables), variables);
    }

    public rellenarPdfSolicitud(polizaId: number): Promise<Archivo> {
        const variables = { polizaId };
        return this.apiService.query(getGQLQueryString(ArchivoQuery.rellenarPdfSolicitud, variables), variables);
    }

}
